<template>
    <div class="sidebar-wrapper" :class="{'hide': isClosed}" v-loading="sidebarLoading">

        <span v-if="!isClosed" class="sidebar-toggle" @click="toggleBar()">hide menu</span>
        <span v-else class="sidebar-toggle hide" @click="toggleBar()">show menu</span>

        <div class="sidebar" :class="{'hide': isClosed}">
            <div class="sidebar-inner">

                <div class="sidebar-list primary">

                    <div class="sidebar-list-breadcrumbs">
                        <p class="sidebar-list-title" @click="resetCategoryLocal">
                            {{this.$store.state.rootPath | formatRootFolderName}}
                        </p>
                        <p v-if="$store.state.activeCategory" class="sidebar-list-title"  @click="setCategoryLocal($store.state.activeCategory)">
                            {{$store.state.activeCategory}}
                        </p>
                    </div>

                </div>

                <div class="sidebar-filter">
                    <template>
                        <div class="sidebar-list dropdown"
                             v-for="(item, filter) in Object.keys($store.state.filters).sort()
                              .filter(key => $store.state.activeCategory === key)
                              .reduce((obj, key) => {
                                obj[key] = $store.state.filters[key]
                                return obj
                              }, {})"
                             :key="filter"
                             :class="{'active': $store.state.expandedFilter.indexOf(filter) !== -1}">
                            <p class="sidebar-list-title" @click="setExpandedFilterLocal(filter)">Subcategory</p>

                            <div class="sidebar-list-inner">
                                <label class="sidebar-list-item" v-for="check in item" :key="check">
                                    <input type="checkbox" :value="check" :id="check" v-model="$store.state.checkedValues" @change="setFilterLocal(filter, check, item, 1000)">
                                    <span class="checkmark"></span>
                                    {{check}}
                                </label>
                            </div>
                        </div>
                    </template>
                    <template v-for="filter in $store.state.filtersOrder">
                        <template v-if="typeof $store.state.filters[filter] !== 'undefined'">
                            <div class="sidebar-list dropdown"
                                 :key="filter"
                                 :class="{'active': $store.state.expandedFilter.indexOf(filter) !== -1}">
                                <p class="sidebar-list-title" @click="setExpandedFilterLocal(filter)">{{filter}}</p>

                                <div class="sidebar-list-inner">
                                    <label class="sidebar-list-item" v-for="check in $store.state.filters[filter]" :key="check">
                                        <input type="checkbox" :value="check" :id="check" v-model="$store.state.checkedValues" @change="setFilterLocal(filter, check, $store.state.filters[filter], 1000)">
                                        <span class="checkmark"></span>
                                        {{check}}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </template>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'
import axios from 'axios'

const CancelToken = axios.CancelToken

export default {
  name: 'SidebarTrims',
  data () {
    return {
      isClosed: false,
      sidebarLoading: false,
      windowWidth: 0,
      searchString: null,
      token: null
    }
  },
  computed: {
    isTrimsFolder: function () {
      return this.$store.state.assetQuery.path === '::EC2AMAZ-6RO630I:Trims'
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    EventBus.$on('reset-category', this.resetCategoryLocal)
    EventBus.$on('search', this.resetCategoryLocal)
  },
  beforeDestroy () {
    EventBus.$off('reset-category', this.resetCategoryLocal)
    EventBus.$off('search', this.resetCategoryLocal)
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.assetQuery.filter': {
      handler () {
        if (!this.$store.state.assetQuery.filter.length) {
          this.setSidebarValues('activeFilter', [])
          this.setSidebarValues('checkedValues', [])
        }
      },
      deep: true
    }
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    toggleBar () {
      this.isClosed = !this.isClosed
      EventBus.$emit('sidebar-toggle', this.isClosed)
    },
    loadFilters () {
      if (this.$store.state.assetQuery.path !== '') {
        if (this.token) {
          this.token.cancel()
        }
        this.token = CancelToken.source()

        this.sidebarLoading = true
        HTTP({
          method: 'GET',
          url: '/api/v1/assets/filters',
          params: {
            path: this.$store.state.assetQuery.path,
            search: this.$store.state.assetQuery.search,
            filter: this.$store.state.assetQuery.filter,
            imageSize: this.$store.state.assetQuery.imageSize,
            sort: this.$store.state.assetQuery.sort
          },
          cancelToken: this.token.token,
          crossdomain: true
        })
          .then(response => {
            if (response.data.data) {
              this.sidebarLoading = false
              this.setSidebarValues('filters', typeof response.data.data.filters !== 'undefined' ? response.data.data.filters : [])
              this.setSidebarValues('filtersOrder', typeof response.data.data.order !== 'undefined' ? response.data.data.order : [])
            }
          })
          .catch(() => {
            this.sidebarLoading = false
            this.setSidebarValues('filters', [])
          })
      }
    },
    setExpandedFilterLocal (filter) {
      this.setExpandedFilter(filter)
    },
    setCategoryLocal (cat) {
      this.setCategory(cat)
      this.loadFilters()
      if (this.windowWidth < 769) {
        this.isClosed = false
      }
    },
    resetCategoryLocal () {
      this.resetCategory()
      this.loadFilters()

      if (this.windowWidth < 769) {
        this.isClosed = false
      }
    },
    setFilterLocal (key, value = null, values = null, debounceDuration = false) {
      this.setFilter(key, value, values, debounceDuration)
    }
  }
}
</script>
